<template>
  <div>
    <div class="form-container ou-donation-form">
      <div class="holder">
      <div style="display:none;">{{totalTicketQty}}</div>
        <div class="form__closed" v-if="!formStatus">
        </div>
        <PaymentForm class="form-horizontal" v-else>
          <FormSection title="">
            <div>
              <div class="smallnote">
                <strong>Event Price Per Person</strong><br />
                Price: <span style="color: #900">Tickets are CA$65 with a CA$30 tax receipt</span>
              </div>
              <div>
                <div
                  class="teach-styled styled-radio-container styled-radio-container--ou-donation row"
                >
                  <label class="label__lg" for="ticketsQnt"
                    >How many people are attending?</label
                  >
                  <div class="amount-row tickets-num">
                    <input
                      id="ticketsQnt"
                      type="number"
                      min="1"
                      name="ticketsQnt"
                      placeholder="Number of tickets"
                      v-model="ticketsQnt"
                      @change="customQnt = true"
                    />
                  </div>
                </div>
              </div>
              <br/>
              <div class="radio-part">
                <input
                  id="type_attending"
                  name="Attending"
                  type="checkbox"
                  :checked="getValue('custom.attending') == 'no'"
                  @click="setValue('custom.attending', 'no')"
                />
                <FormLabel for="type_attending"> I can not attend but would like to donate </FormLabel>
              </div>
              <FormRow v-if="getValue('custom.attending') == 'no'">
                <div class="amount_other__wrapper" style="max-width: 200px">
                    <input id="amount_other" type="number" min="1" name="amount_other" v-model="customAmount" placeholder="0"/>
                </div>
              </FormRow>
            </div>
          </FormSection>

          <FormSection title="Personal Information">
            <FormRow inline>
              <FormCol field="title" :flex="1" />
              <FormCol field="firstName" :flex="2" />
              <FormCol field="lastName" :flex="2" />
            </FormRow>

            <FormRow inline>
              <FormCol field="email" />
              <FormCol field="phone" />
            </FormRow>
            <FormRow inline>
                      <Consent privacy="https://www.yachad.org/privacy-policy/"/>
                  </FormRow> 
          </FormSection>
          <FormSection title="Billing Address">
            <DonorAddress lang="canada"/>
          </FormSection>
          <FormSection title="Payment Information" last>
            <FormRow inline>
              <FormCol field="card" :showLabel="false" />
            </FormRow>
          </FormSection>
          <PaymentButton showAmount btnText="Submit" />
        </PaymentForm>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {
  computed,
  defineComponent,
  onMounted,
  ref,
  watch,
  nextTick
} from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";

import type { Currency } from "~/form-settings";
import { queryParams } from "~/shared/query-params";

export default defineComponent({  setup(props) {
    const { setValue, getValue, form, settings } = usePaymentForm();

    const formStatus = ref(true);
    const totalTicketQty = ref(0);

    onMounted(() => {
      fetch(
        process.env.NODE_ENV == "production"
          ? "https://donateou.org/api/tornotjust-count"
          : "https://donate.oudev.org/api/tornotjust-count"
      )
        .then(response => response.json())
        .then(data => {
          totalTicketQty.value = data;
          if (data >= 85) {
            formStatus.value = false;
          }
        })
        .catch(error => {
          console.error('Error fetching data:', error);
        });
      });

    const ticketsQnt = ref();
    const customQnt = ref(false);
    const customAmount = ref(0);

    let ticketCost = 0;

    watch(customQnt, async () => {
      customQnt.value = false;
      ticketCost = 65 * ticketsQnt.value;

      await nextTick();
      if (ticketsQnt) {
        setValue("custom.ticketsQnt", ticketsQnt.value);
        setValue('custom.attending', 'yes')
        setValue(
          "amount",
          ticketCost + ""
        );
        customAmount.value = 0;
      }
    });

    watch(customAmount, async (customAmount) => {
      if (customAmount) {
        customQnt.value = false;
        ticketsQnt.value = true;
      }

      // make sure UI has vue has dealt with customSelected and then we'll set the customAmount
      await nextTick();
      if(customAmount && customAmount > 0) {
        setValue("amount", customAmount + "");
      }
    });

    const amounts = computed(() => {
      const amounts = settings!.amounts! as
        | [number, string][]
        | [Partial<{ [key in Currency]: number }>, string][];

      if (typeof amounts[0][0] == "number") return amounts;

      return (amounts as [
        Partial<{ [key in Currency]: number }>,
        string
        //@ts-ignore
      ][]).map(([amounts, label]) => [amounts[form.value.currency!], label]);
    });

    const params = queryParams();

    return {
      form,
      amounts,
      ticketsQnt,
      formStatus,
      customAmount,
      totalTicketQty,
      customQnt,
      getValue,
      setValue
    };
  },
});
</script>
<style scoped lang="scss">
.form-container.ou-donation-form {
  padding: 20px;
  box-shadow: none;
  max-width: 700px;
  margin: 0px auto;
}
h2 {
  font-weight: 600;
  margin-bottom: 20px;
  margin-top: 0px;
  font-size: 20px;
  color: black;
}
h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
.note {
  font-style: italic;
  line-height: 1.4;
  font-weight: bold;
  font-size: 14px;

  a {
    text-decoration: none;
  }
}
::v-deep .amount-row {
  min-width: 31.3333% !important;
  max-width: 31.3333% !important;
}
::v-deep .styled-radio-container--ou-donation.styled-radio-container {
}

.subnote {
  width: 100%;
  font-size: 14px;
  color: #222;
  padding-top: 3px;
  padding-bottom: 20px;
  display: block;
  line-height: inherit;
  font-family: inherit;
  letter-spacing: normal;
  margin-bottom: 9px;
  border-bottom: 1px solid #ccc;
  a {
    color: #1aa8d3;
    text-decoration: none;
  }
}

.smallnote {
  line-height: 1.4;
  margin-bottom: 20px;
}
label.label__lg {
  display: block;
  padding-bottom: 5px;
  background: inherit;
  color: inherit;
  text-align: left;
  border: none;
}

.teach-styled.styled-radio-container.styled-radio-container--ou-donation.row {
  margin: 0px;
}

::v-deep .row {
  margin: 0px;
}

.amount__nonetickert {
  position: relative;
  min-width: 200px !important;
  max-width: 200px !important;
  overflow: hidden;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding-left: 5px;
  flex: 1;
  line-height: 1;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  width: 100%;
  &:before {
    content: "$";
    font-weight: 500 !important;
    position: absolute;
    padding: 15px 8px;
    border-right: 1px solid #ddd;
    height: 100%;
    background: #f7f7f7;
    text-align: center;
    top: 0;
    left: 0;
    width: 70px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  input[type="radio"] {
    height: 0;
    top: 20px;
    position: absolute;
    left: 20px;
    z-index: -1;
    visibility: hidden;
    margin-right: 7px;
  }
  #amount_other {
    border: none;
    background: #fff;
    margin-left: 70px;
    box-shadow: none;
    height: 42px;
    max-width: 200px;
  }
}
.radio-part {
  display: flex;
  gap: 10px;
  align-items: center;
  padding-bottom: 7px;
}
</style>
